import { createBrowserRouter, Navigate } from "react-router";
import { authRoutes } from "@/src/auth/routes";
import AdminLayout from "@/src/common/layouts/admin-layout";
import { AuthGuard } from "@/src/common/navigations/auth-guard";
import { dashboardRoutes } from "@/src/dashboard/routes";
import { oauthRoutes } from "@/src/oauth/routes";
import { seriesRoutes } from "@/src/series/routes";
import { settingsRoutes } from "@/src/settings/routes";
import { storiesRoutes } from "@/src/stories/routes";
import { usersRoutes } from "@/src/users/routes";

export const rootRouter = createBrowserRouter([
	...authRoutes,
	{
		element: <AuthGuard />,
		children: [
			...oauthRoutes,
			{
				element: <AdminLayout />,
				children: [...seriesRoutes, ...storiesRoutes, ...usersRoutes, ...dashboardRoutes, ...settingsRoutes],
			},
		],
	},
	{ path: "*", element: <Navigate to="/" replace /> },
]);
